import React, { LegacyRef } from 'react';
import { Box } from '@styleseat/ui';

/**
 * This is a good candidate for being moved to the UI folder.
 * This component renders a video tag with a border radius
 */
export const Video = React.forwardRef(({
  borderRadius,
  sources,
  onClick,
  controls = false,
  playsInline = false,
  disablePictureInPicture = false,
  autoplay = false,
  muted = false,
}: {
  borderRadius: number;
  sources: {
    src: string;
    type: string;
  }[];
  onClick: (event) => void;
  controls?: boolean;
  playsInline?: boolean;
  disablePictureInPicture?: boolean;
  autoplay?: boolean;
  muted?: boolean;
}, ref: LegacyRef<HTMLVideoElement>) => (
  <Box borderRadius={borderRadius} overflow="hidden">
    {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
    <video
      width="100%"
      height="auto"
      ref={ref}
      onClick={onClick}
      controls={controls}
      playsInline={playsInline}
      disablePictureInPicture={disablePictureInPicture}
      autoPlay={autoplay}
      muted={muted}
    >
      {sources.map(source => (
        <source
          key={source.src}
          src={source.src}
          type={source.type}
        />
      ))}
    </video>
  </Box>
));
